import { render, staticRenderFns } from "./StatsMarketingKpi.vue?vue&type=template&id=9c29ce18"
import script from "./StatsMarketingKpi.vue?vue&type=script&lang=js"
export * from "./StatsMarketingKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports